import { render, staticRenderFns } from "./VInvoice.vue?vue&type=template&id=7054a372&"
import script from "./VInvoice.vue?vue&type=script&lang=js&"
export * from "./VInvoice.vue?vue&type=script&lang=js&"
import style0 from "./VInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports